import type * as THREE from "three";
import { Layers } from "three";
import {
  BUILDING_EXTERIOR_LAYER,
  BUILDING_INTERIOR_LAYER,
  CLIPPING_LAYER,
  SITE_CAMERA_FADE_LAYER,
  SITE_LAYER,
  UI_LAYER,
} from "./layerConstants";

export function assignToInteriorLayer(o: THREE.Object3D, clip: boolean = true) {
  o.layers.set(BUILDING_INTERIOR_LAYER);
  if (clip) {
    o.layers.enable(CLIPPING_LAYER);
  }
}

export function assignToBuildingExteriorLayer(o: THREE.Object3D, clip: boolean = true) {
  o.layers.set(BUILDING_EXTERIOR_LAYER);
  if (clip) {
    o.layers.enable(CLIPPING_LAYER);
  }
}

export function assignToSiteLayer(o: THREE.Object3D, cameraFade: boolean = false) {
  if (cameraFade) {
    o.layers.set(SITE_CAMERA_FADE_LAYER);
  } else {
    o.layers.set(SITE_LAYER);
  }
}

export function assignToUILayer(o: THREE.Object3D) {
  o.layers.set(UI_LAYER);
}

export function interiorLightLayers() {
  const layers = new Layers();

  layers.set(BUILDING_INTERIOR_LAYER);

  return layers;
}

export function exteriorLightLayers() {
  const layers = new Layers();

  layers.set(SITE_LAYER);
  layers.enable(SITE_CAMERA_FADE_LAYER);
  layers.enable(BUILDING_EXTERIOR_LAYER);

  return layers;
}

export function allLayers() {
  const layers = new Layers();
  layers.enableAll();

  return layers;
}
